export const ZIndex = {
  Overlay: 1000,
  Loader: 10000,
  Dropdown: 20000,
  Modal: 100000,
  Popup: 1000000,
};
